import type { ColDef, ICellRendererComp, ICellRendererParams } from 'ag-grid-community';
import { isDefined } from '../../shared/isDefined';
import { getTooltipText } from './withIndicatorCellRenderer';

type OptimizedWithIndicatorCellRendererParams = {
  value?: unknown,
  valueFormatted?: string | null,
  data: Record<PropertyKey, unknown>,
  colDef?: ColDef,
}


const indicator = (tooltipText: string) => `<div class="with-indicator" data-tip="${tooltipText}" ></div>`;
// JS cell renderer to improve performance
export class OptimizedWithIndicatorCellRenderer implements ICellRendererComp {
  public cellValue: string = '';
  public eGui!: HTMLDivElement;

  init(params: OptimizedWithIndicatorCellRendererParams) {
    this.eGui = document.createElement('div');

    this.cellValue = this.getValueToDisplay(params);
    this.eGui.innerHTML = this.cellValue;
  }

  getGui() {
    return this.eGui!;
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = this.getValueToDisplay(params);
    this.eGui.innerHTML = this.cellValue;

    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  getValueToDisplay(params: OptimizedWithIndicatorCellRendererParams) {
    const { value, valueFormatted, data, colDef } = params;

    const tooltipText = getTooltipText(data, colDef);

    const displayedValue = valueFormatted ?? value;

    return `
      <div>
        ${isDefined(displayedValue) ? displayedValue : ''}
        ${tooltipText ? indicator(tooltipText) : ''}
      </div>
      `;
  }
}
